import { v4 as uuidv4 } from 'uuid';

export function SellerShipping(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerShipping',
		componentId: uuidv4(),
		title: '',
		props: Object.assign({}, props),
		childrenComponents,
	};
}
